import { JournalFeed } from "../../components/journal/JournalFeed";

/**
 * Surface C — the org-level Journal service screen. Renders the unfiltered
 * feed across the whole organization with the filter bar enabled so admins
 * can pivot by category, severity, actor, primary resource, correlation id,
 * etc. Simulations are excluded by default (operators can re-enable them
 * via the filter bar).
 *
 * Server-side enforcement in api-warrior remains the authoritative source
 * of truth for access to journal data.
 */
export function JournalService() {
  return (
    <JournalFeed
      defaultFilters={{ includeSimulations: false }}
      title="Journal"
    />
  );
}
